<template>
  <div class="function-bd tb" v-if="funcView.module_fun_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addFunc" v-if="funcView.module_fun_add">{{ funcView.module_fun_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            v-model="appId"
            url="AppMenu"
            :isDefault="true"
            :clearable="false"
            :props="{ label: 'appName', value: 'appId' }"
            :placeholder="$t('Common.com_please_select')"
            width="200px"
            :dataFilter="dataFilter"
            @init="getFuncTree"
            @change="getFuncTree"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table row-key="funcId" tableCode="moduleFun" v-loading="isLoading" :data="funcTree" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
        <el-table-column :label="$t('Common.com_handle')" min-width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editFunc(scope.row)" v-if="funcView.module_fun_edit">{{ funcView.module_fun_edit }}</el-button>
            <el-button type="text" size="mini" @click="deleteFunc(scope.row)" v-if="funcView.module_fun_delete">{{ funcView.module_fun_delete }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <func-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getFuncTree"></func-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import funcItemDialog from './children/func_item_dialog';

export default {
  name: 'func',
  components: { funcItemDialog },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},

      form: {
        pageSize: 20,
        pageNum: 1,
        search: '',
      },
      formSearch: {
        appId: '',
      },

      appId: '',
      appList: [],
      funcTree: [],
    };
  },
  mounted() {
    this.getFuncView();
  },
  methods: {
    // 应用平台(过滤)
    dataFilter: function (list) {
      return list.filter(t => t.appCode !== 'isynergy_cloud');
    },
    // 获取菜单功能树
    getFuncTree: function () {
      this.isLoading = true;
      this.formSearch.appId = this.appId;
      this.$getJSON(apis.FuncTree, this.formSearch).then((res) => {
        this.isLoading = false;
        this.funcTree = res.data || [];
      });
    },
    // 变更
    onPageChange: function () {
      this.getFuncTree();
    },
    // 新增功能项
    addFunc: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_function.xzmkgn');
      this.dialogModel.data = { appId: this.appId };
      this.dialogVisible = true;
    },
    // 编辑字典组
    editFunc: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_function.bjmkgn');
      this.dialogModel.data = { appId: this.appId, item: data };
      this.dialogVisible = true;
    },
    // 删除功能项
    deleteFunc: function (data) {
      this.$showConfirm(this.$t('base_function.nqdyscxzdmkgnm'))
        .then(() => {
          this.$postJSON(`${apis.FuncDelete}/${data.funcId}`).then(() => {
            this.expandedKeys = [data.parentId];
            this.getFuncTree();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.function-bd {
  .search-select {
    input {
      color: $main-color;
    }
  }
}
</style>
